import { Component, Input, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { HttpClient } from '@angular/common/http';
import { UiService } from '../../../core/services/core.ui.service';
import {decodeParams, normalizeCommitish} from '../services/scm.utils';
import * as _ from 'lodash';

@Component({
  selector: 'scm-tree',
  template: require('./scm.tree.component.html'),
})
export class ScmTreeComponent implements OnInit {
  @Input() breadcrumbs: any;
  @Input() scm: any;

  files: any = false;
  readme: any = false;
  emptyRepository: boolean = false;

  commitish: string = '';
  commitishLabel: string;
  upFolder: any;

  constructor(
    private stateService: StateService,
    private http: HttpClient,
    private uiService: UiService,
    private $window: Window
  ) {}

  ngOnInit() {

    let params = decodeParams(this.stateService.params);
    this.commitish = normalizeCommitish(
      params['branch'] || params['tag'] || params['commit']
    );
    this.commitishLabel = this.getLabel(params).toLowerCase();

    if (!this.commitish) {
      if (this.scm.scmType == 'git') {
        this.commitish = 'master';
        this.commitishLabel = 'branch'
      }
    }

    if (this.breadcrumbs && this.breadcrumbs.length > 2) {
      const parentCrumb = this.breadcrumbs[this.breadcrumbs.length - 2];
      const pathSegments = (params['path'] || '').split('/').filter((s: string) => s !== '');
      const parentPath = pathSegments.slice(0, -1).join('/');
      this.upFolder = {
        label: parentCrumb.label,
        stateRef: 'home.project.summary.scm.browse',
        stateParams: { ...params, path: parentPath }
      };
    } else {
      this.upFolder = false;
    }
    const queryParts = this.commitish
      ? [`${this.commitishLabel}=${encodeURIComponent(this.commitish)}`]
      : [];
    const queryString = queryParts.length ? `?${queryParts.join('&')}` : '';
    let path = decodeURIComponent(params['path'] || '');
    if (path.startsWith('/')) {
      path = path.substring(1);
    }
    if (!path.endsWith('/')) {
      path += '/';
    }
    const unixName = params['unixName'];
    const url = `/api/scm/${unixName}/tree/${path}${queryString}`;

    this.http.get(url).subscribe(
      (response: any) => {
        this.files = this.sortFiles(_.get(response, 'items', []));
        this.emptyRepository = false;

        const readme = _.filter(this.files, { type: 'file' }).find((f) => {
          const pieces = _.get(f, 'name', '').split('.');
          const fname = _.lowerCase(_.get(pieces, '[0]', ''));
          return fname === 'readme';
        });

        if (readme) {
          const readmeParams = [...queryParts, 'rel=raw'];
          const readmeQuery = readmeParams.length ? `?${readmeParams.join('&')}` : '';
          const readmeUrl = `/api/scm/${unixName}/file/${path}${encodeURIComponent(
            readme.name
          )}${readmeQuery}`;

          this.http.get(readmeUrl).subscribe((readmeResponse: any) => {
            if (readmeResponse.isLfs) {
              this.readme = {
                title: _.get(readmeResponse, 'name', 'README'),
                isLfs: true,
                lfsDownloadUrl: readmeResponse.lfsOid
                  ? `/api/scm/${unixName}/lfs?oid=${readmeResponse.lfsOid}`
                  : null,
              };
            } else {
              this.readme = {
                title: _.get(readmeResponse, 'name', 'README'),
                type: _.get(readmeResponse, 'name', '').split('.').pop(),
                content: _.get(readmeResponse, 'rel.raw', ''),
              };
            }
          });
        }

      },
      (error) => {
        if (
          error.status === 404 &&
          (params['path'] === '' || params['path'] === '/')
        ) {
          this.emptyRepository = true;
        } else {
          this.uiService.message.showWarning(
            'The path /' + params['path'] + ' does not exist in this branch/tag',
            'No Data Available'
          );
        }
        this.files = [];
      }
    );
  }

  sortFiles(files: any[]) {
    return _.sortBy(_.filter(files, { type: 'folder' }), 'name')
      .concat(_.sortBy(_.filter(files, { type: 'file' }), 'name'));
  }

  entryStateName(isFile: boolean): string {
    return isFile ? 'home.project.summary.scm.file' : 'home.project.summary.scm.browse';
  }

  entryStateParams(name: string): object {
    const params: any = { ...this.stateService.params };
    const currentPath = params['path'] || '';
    params['path'] = currentPath === '' ? name : `${currentPath}/${name}`;
    return decodeParams(params);
  }
  exportDir(format: string) {
    const url = this.stateService.href(this.stateService.current.name, this.stateService.params);
    const match = url.match(/browse\/([^?]*)/);
    const path = match ? match[1] : null;
    const unixName = this.stateService.params.unixName;
    if (!this.commitish || this.commitish == 'SVN Root') {
      if (this.scm.scmType == 'svn') {
        this.commitish = 'HEAD';
        this.commitishLabel = 'commit';
      }
    }
    if (!this.commitish || this.commitish == 'CVS Root') {
      if (this.scm.scmType == 'cvs') {
        this.commitish = 'HEAD';
        this.commitishLabel = 'commit';
      }
    }


    const baseUrl = '/api/scm';
    const tarballParams = [`format=${encodeURIComponent(format)}`];
    if (this.commitish) {
      tarballParams.push(`${this.commitishLabel}=${encodeURIComponent(this.commitish)}`);
    }
    const tarballQuery = tarballParams.length ? `?${tarballParams.join('&')}` : '';
    const tarballUrl = `${baseUrl}/${unixName}/raw/${path}${tarballQuery}`;

    this.$window.open(tarballUrl, '_self');
  }

  downloadLfsReadme(): void {
    if (!this.readme || !this.readme.lfsDownloadUrl) {
      return;
    }
    this.http.get(this.readme.lfsDownloadUrl, { responseType: 'blob' }).subscribe(
      (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = this.readme.title || 'README';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      },
      () => {
        this.uiService.message.showWarning('Failed to download LFS file', 'Download Error');
      }
    );
  }

  private getLabel(stateParams: any): string {
    if (!stateParams['branch']) {
      if (stateParams['commit']) {
        return 'Commit';
      }
      if (stateParams['tag']) {
        return 'Tag';
      }
    }
    return 'Branch';
  }
}
